import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Fetch a CMS-managed content list; fall back to the bundled static content when the
 * CMS has no published items (or the request fails), so the public site never breaks.
 */
/** Normalize CMS pair rows ([label, value]) or static objects ({label, value}) to SpecTable rows. */
export const toSpecRows = (items) => (items || []).map((it) => (Array.isArray(it) ? it : [it.label, it.value]));

export const useCmsList = (type, fallback) => {
  const [items, setItems] = useState(fallback);
  useEffect(() => {
    let on = true;
    axios.get(`${API}/content/${type}`)
      .then((r) => { if (on && Array.isArray(r.data) && r.data.length) setItems(r.data); })
      .catch(() => {});
    return () => { on = false; };
  }, [type]); // eslint-disable-line react-hooks/exhaustive-deps
  return items;
};

/** Fetch a CMS-managed singleton (home / contact / navigation_meta); merge over the static fallback. */
export const useCmsSingleton = (type, fallback) => {
  const [data, setData] = useState(fallback);
  useEffect(() => {
    let on = true;
    axios.get(`${API}/content/${type}`)
      .then((r) => { if (on && r.data && Object.keys(r.data).length) setData((prev) => ({ ...prev, ...r.data })); })
      .catch(() => {});
    return () => { on = false; };
  }, [type]); // eslint-disable-line react-hooks/exhaustive-deps
  return data;
};
